import { motion } from "framer-motion";

export const InvoiceTotals = ({ totals }) => {
  const totalItems = [
    { label: "Total Before Tax", value: totals?.totalBeforeTax || 0 },
    { label: "Retention Amount", value: totals?.retentionAmount || 0 },
    { label: "Total VAT Amount after Retention", value: totals?.totalVatAfterRetention || 0 },
    { label: "Advance Received", value: totals?.advanceReceived || 0 },
    { label: "Balance Before Tax", value: totals?.totalBeforeTax || 0 },
    { label: "Tax on Advance", value: totals?.taxOnAdvance || 0 },
    { label: "Balance Tax Amount", value: totals?.balanceTaxAmount || 0 },
    { label: "Balance After Tax", value: totals?.finalAmount || 0, isFinal: true }
  ];

  return (
    <motion.div
      className="bg-gradient-to-br from-gray-50 to-gray-200 p-8 rounded-2xl shadow-2xl mt-6 border border-gray-300"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {/* Heading */}
      <h3 className="text-3xl font-extrabold text-gray-800 mb-6 tracking-wide text-center">
        Invoice Totals
      </h3>

      {/* Totals Grid - 2 Columns for Better Balance */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {totalItems.map((item, index) => (
          <motion.div
            key={index}
            className={`flex justify-between items-center p-5 rounded-xl shadow-lg border transition-all duration-300 hover:shadow-2xl transform hover:scale-105
              ${item.isFinal
                ? "bg-gradient-to-r from-blue-500 to-purple-600 text-white font-extrabold text-lg border-none"
                : index % 2 === 0
                  ? "bg-gradient-to-br from-blue-100 to-gray-200 border-gray-300 text-gray-900"
                  : "bg-gradient-to-br from-gray-100 to-gray-300 border-gray-400 text-gray-800"
              }`
            }
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.4 }}
          >
            <span className={`text-md font-semibold ${item.isFinal ? "text-white" : "text-gray-700"}`}>
              {item.label}
            </span>
            <span className={`text-lg font-bold ${item.isFinal ? "text-white text-xl" : "text-gray-900"}`}>
              {item.value}
            </span>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};
